import { EventType } from "./types-and-interfaces/logging-types-constants";
import { useEventDescriptions } from "./useEventDescriptions";
import { tealiumClient } from "../clients/tealiumClient";

const testMode = false; /* DEVNOTE set this true for testing, so it logs info into console */

export const useLogger = () => {
	const { publish } = tealiumClient();
	const { EVENT_DESCRIPTIONS } = useEventDescriptions();

	// EXPORTS

	const logEvent = <T>(eventType: EventType, eventParams: T) => {
		const mapItem = EVENT_DESCRIPTIONS.get(eventType);

		const eventName = mapItem?.postedEventName || eventType;

		const rawParams: Record<string, unknown> = {
			tealium_event: eventName,
		};

		if (mapItem.customProperties) {
			const customParams = mapItem.customProperties(eventParams);
			Object.assign(rawParams, customParams);
		}

		const params: Record<string, string> = Array.from(Object.keys(rawParams))
			.sort((a, b) => (a === "tealium_event" ? -1 : b === "tealium_event" ? 1 : a.localeCompare(b)))
			.reduce((obj, key) => {
				const val = rawParams[key];
				if (
					val ||
					(val as unknown as boolean) === false ||
					(val as unknown as number) === 0
				) {
					obj[key] = String(val);
				}
				return obj;
			}, {} as Record<string, string>);

		publish(eventName, params, testMode);
	};

	return { logEvent };
};
